import { getSpecificEnv } from '@availity/env-var';

const specificEnv = getSpecificEnv();

const getBaseAvUrl = () => {
  let output;
  switch (specificEnv) {
    case 'prod': {
      output = 'https://apps.availity.com';
      break;
    }
    case 'local': {
      output = 'http://localhost:3000';
      break;
    }
    default: {
      output = `https://${specificEnv}-apps.availity.com`;
    }
  }

  return output;
};

export default getBaseAvUrl;
